import { JDSTableBodyProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSTableBodyProps>
  ): React.FC<JDSTableBodyProps> =>
  (props: JDSTableBodyProps) => {
    return <Component {...props} />;
  };
